import AppBar from "@material-ui/core/AppBar";
import Hidden from "@material-ui/core/Hidden";
//import IconButton from "@material-ui/core/IconButton";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
// @material-ui/icons
//import Menu from "@material-ui/icons/Menu";
import styles from "assets/jss/style-component/components/headerStyle.js";
//import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
// core components
import AdminNavbarLinks from "./AdminNavbarLinks.js";

const useStyles = makeStyles(styles);

export default function Header(props) {
  const classes = useStyles();

  function makeBrand() {
    var name;
    props.routes.map(prop => {
      if (
          window.location.href.indexOf(prop.layout + prop.path) !== -1 &&
          prop.path !== "/"
      ) {
        name = prop.name;
      }
      return null;
    });
    return name;
  }

  return (
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.container}>
          <div className={classes.title}>
            <Hidden implementation="css">
              <AdminNavbarLinks nombrePantalla={makeBrand()} />
            </Hidden>
          </div>
        </Toolbar>
      </AppBar>
  );
}

Header.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
  open: PropTypes.string
};
